import { Container, Eyebrow } from './primitives'
import { Gallery, ShippedGrid } from './gallery'

export function WorkSection() {
  return (
    <section
      id="work"
      style={{
        padding: '96px 0',
        borderTop: '1px solid var(--line)',
        overflow: 'hidden',
      }}
    >
      <Container>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            marginBottom: 56,
            flexWrap: 'wrap',
            gap: 24,
          }}
        >
          <div>
            <Eyebrow>Selected work</Eyebrow>
            <h2
              style={{
                fontSize: 'clamp(32px, 4vw, 48px)',
                lineHeight: 1.05,
                letterSpacing: '-0.025em',
                fontWeight: 400,
                margin: '20px 0 0',
                fontFamily: 'var(--serif)',
                maxWidth: 720,
              }}
            >
              Recent sites and example layouts.
            </h2>
            <p
              style={{
                fontSize: 14,
                color: 'var(--muted)',
                fontFamily: 'var(--mono)',
                letterSpacing: '0.04em',
                marginTop: 16,
                textTransform: 'uppercase',
              }}
            >
              Two shipped sites and six layouts built for fractional execs. Your site ships in seven days.
            </p>
          </div>
          <a
            href="#pricing"
            style={{
              fontSize: 14,
              color: 'var(--fg)',
              borderBottom: '1px solid var(--line-strong)',
              padding: '4px 0',
            }}
          >
            Start yours →
          </a>
        </div>
        <ShippedGrid />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            margin: '96px 0 40px',
          }}
        >
          <Eyebrow>Layout examples</Eyebrow>
          <div style={{ flex: 1, height: 1, background: 'var(--line)' }} />
          <span
            style={{
              fontFamily: 'var(--mono)',
              fontSize: 12,
              color: 'var(--muted)',
              letterSpacing: '0.08em',
            }}
          >
            Frames for fractional execs
          </span>
        </div>
        <Gallery />
      </Container>
    </section>
  )
}
